import { useHyperMainSync } from "#/hooks/use-hyper-main-sync";
import { useHyperUserEvents } from "#/hooks/use-hyper-user-events";
import { useHyperXyzSync } from "#/hooks/use-hyper-xyz-sync";

/**
 * Mounts the three Hyperliquid WS sync hooks once at the root (`__root.tsx`).
 * They read the wallet address from `useWallet()` (session-backed) and stay
 * disabled until a user is logged in.
 */
export function HyperUserEventsSync() {
	useHyperUserEvents();
	useHyperMainSync();
	useHyperXyzSync();
	return null;
}
